import React from 'react';

import {Skeleton, Stack} from 'views/components';

const TaskListSkeleton = () => {
  return (
    <Stack spacing={1.5}>
      <Skeleton variant="rounded" height={28} />
      <Skeleton variant="rounded" height={28} />
    </Stack>
  );
};

export default React.memo(TaskListSkeleton);
